<template>
  <v-dialog :max-width="650" :value="value" persistent>
    <v-card>
      <v-toolbar dark color="grey lighten-3" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold grey--text"> {{ title }} </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4 black--text">
        <div v-html="message"></div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn type="submit" @click="confirmAction" color="primary" class="text-none">{{ primaryButtonLabel }}</v-btn>
        <v-btn @click="cancelAction" class="text-none">{{ secondaryButtonLabel }}</v-btn>
        <v-btn v-if="tertiaryButtonLabel" @click="closeModal" class="text-none">{{ tertiaryButtonLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
  import Vue from 'vue';
  export default Vue.extend({
    props: {
      value: { type: Boolean, default: false },
      title: { type: String, default: 'Confirm Action' },
      message: { type: String, default: '' },
      primaryButtonLabel: { type: String, default: 'Confirm' },
      secondaryButtonLabel: { type: String, default: 'Cancel' },
      tertiaryButtonLabel: { type: String, default: '' },
    },
    data() {
      return {
        loading: false,
        disabled: false,
      };
    },
    methods: {
      confirmAction() {
        this.$emit('confirm');
        this.closeModal();
      },
      cancelAction() {
        this.$emit('cancel');
        this.closeModal();
      },
      closeModal() {
        this.$emit('input', false);
      },
    },
  });
</script>
